import React from "react";
import PropTypes from "prop-types";
import { ThemeProvider } from "styled-components";
import { default as GlobalStyles } from "./GlobalStyles";
import systemtheme from "./systemtheme";

const SystemThemeProvider = ({ children, theme = systemtheme }) => {
  return (
    <ThemeProvider theme={theme}>
      <>
        <GlobalStyles />
        {children}
      </>
    </ThemeProvider>
  );
};

SystemThemeProvider.propTypes = {
  children: PropTypes.node,
  theme: PropTypes.object
};

export default SystemThemeProvider;
